import CodeEditorSubheader, { CodeEditorSubheaderProps } from './CodeEditorSubheader';

export type { CodeEditorSubheaderProps };
export default CodeEditorSubheader;
